import { Minus, Plus } from "lucide-react";

const SIZES = {
  md: { btn: "h-11 xl:h-12 flex-1 min-w-[30px] max-w-[60px]", num: "w-[22px] xl:w-7 text-xl xl:text-2xl" },
  lg: { btn: "h-11 sm:h-12 flex-1 min-w-[38px] max-w-[64px]", num: "w-6 text-xl" },
};

export default function Counter({ value, onPlus, onMinus, group, flash, testid, disabled, size = "md" }) {
  const sz = SIZES[size];
  return (
    <div className="flex items-center justify-center gap-0.5 w-full" data-testid={testid}>
      <button
        type="button"
        disabled={disabled || value <= 0}
        onClick={onMinus}
        data-testid={`${testid}-minus`}
        className={`dv-btn ${sz.btn} rounded-xl flex items-center justify-center disabled:opacity-30 ${group.minus}`}
        aria-label="minus"
      >
        <Minus className="h-5 w-5" strokeWidth={3} />
      </button>
      <span
        data-testid={`${testid}-value`}
        className={`${sz.num} shrink-0 text-center font-heading font-black tabular-nums text-slate-900 ${flash ? "dv-pop" : ""}`}
      >
        {value}
      </span>
      <button
        type="button"
        disabled={disabled}
        onClick={onPlus}
        data-testid={`${testid}-plus`}
        className={`dv-btn ${sz.btn} rounded-xl flex items-center justify-center disabled:opacity-30 disabled:shadow-none ${group.plus}`}
        aria-label="plus"
      >
        <Plus className="h-6 w-6" strokeWidth={3.5} />
      </button>
    </div>
  );
}
